// Object.hasOwn polyfill for Safari < 15.4 compatibility
if (typeof (Object as any).hasOwn !== 'function') {
  (Object as any).hasOwn = function(obj: object, prop: PropertyKey): boolean {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
}

import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import 'uno.css';
import './sentry/index.ts';
import React from 'react';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

window.addEventListener('storage', (e) => {
  if (e.key === 'company-tab-check' && e.newValue) {
    // 不是本tab发起的检测才响应
    if (!document.hasFocus()) {
      console.log('收到tab检测，设置下tab = ', e.newValue);
      localStorage.setItem('company-tab-response', e.newValue);
      setTimeout(() => localStorage.removeItem('company-tab-response'), 100);
    }
  }
});
